module.exports = __webpack_public_path__ + "img/S1-Ships.020343e0.png";